import React from 'react';
import styles from './SliderInput.module.css';

const SliderInput = ({ value, min = 0, max = 100, step = 1, onChange, onMouseUp, onTouchEnd }) => {
    const calculateThumbPosition = () => {
        const numericValue = Number(value);
        const numericMin = Number(min);
        const numericMax = Number(max);
        const percentage = ((numericValue - numericMin) * 100) / (numericMax - numericMin);

        if (numericValue === numericMin) return `${percentage - 0.1}%`;

        if (numericValue === numericMax) return `${percentage + 0.1}%`;

        return `${percentage}%`;
    };
    return (
        <div className={styles.sliderContainer}>
            <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={onChange}
                onMouseUp={onMouseUp}
                onTouchEnd={onTouchEnd}
                className={styles.slider}
                // style={{ backgroundSize: `${((value - min) * 100) / (max - min)}% 100%` }}
            />
            <div className={styles.thumbContainer} style={{ left: calculateThumbPosition(), transform: `translateX(-${calculateThumbPosition()})`, }}>
                <div className={styles.thumb}>
                    <div className={styles.stripe} />
                    <div className={styles.stripe} />
                    <div className={styles.stripe} />
                </div>
            </div>
        </div>
    );
};

export default SliderInput;
